import React from 'react';

import { TOOL_IDS } from '@adsk/alloy-provider';
import { PhotoIcon } from '@adsk/alloy-react-icon';

import {
  MeetingItemEntityBlock,
  MeetingItemEntityMenuItem,
} from './components';
import { getEntitiesByIds } from './helpers';
import { useTranslation } from './i18n';
import { MeetingItem } from './types';
// eslint-disable-next-line
// @ts-ignore
import MissingEntities from '../../blocks/MissingEntities';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';

const PluralText = ({ lowerCase }: Record<string, unknown>) => {
  const { t } = useTranslation();
  const result = t('MEETING_ITEMS');
  if (lowerCase && typeof result === 'string') {
    return result.toLowerCase();
  }
  return result;
};

// see libs/reference-picker/template.js for details on plugin props
const plugin: ReferencePickerPlugin<MeetingItem> = {
  metadata: {
    domain: 'autodesk-bim360-meetingminutes',
    type: 'meetingitem',
  },
  is3LOSupported: true,
  toolId: TOOL_IDS.MEETINGS,
  renderIcon: PhotoIcon.renderIcon,
  PluralText,
  getEntitiesByIds,
  EntityBlock: MeetingItemEntityBlock,
  EntityMenuItem: MeetingItemEntityMenuItem,
  CustomMissingEntities: ({ count, relationshipCount }) => {
    // each meeting followup duplicates all items and their references - new RS entries are created for each followup item
    // the displayed relationships within the plugin shows only the last item in series (see the get entities call above)
    // that means that the RS relationships count is always either greater than or equal to the returned data from our BE

    // if RS relationship count is equal to the missing count (RS count - data count)
    // it means that the data count is 0, and we should show the empty state
    if (relationshipCount === count) {
      return <MissingEntities count={count} />;
    }

    // otherwise we shouldn't show an empty state as RS count is bound to be greater than the data count, and we still want to show the data entries
    return null;
  },
};

export default plugin;
